import { lazy, Suspense, ReactNode } from "react";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

// Icons
const LazyArrowBack = lazy(
  () => import("assets/icons/banger/arrow-left.svg?react"),
);
const LazyClose = lazy(() => import("assets/icons/close-grey.svg?react"));

type PageTitleProps = {
  title?: string | ReactNode;
  titleComponent?: JSX.Element;
  backText?: string;
  className?: string;
  onBack?: (() => void) | null;
  onClose?: (() => void) | null;
};

const PageTitle = (props: PageTitleProps) => {
  const { backText, title, titleComponent, className, onBack, onClose } = props;

  const t = useTranslate();
  const location = useLocation();

  const handleBack = (e) => {
    e.preventDefault();
    if (onBack) {
      onBack();
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    if (onClose) {
      onClose();
    }
  };

  const componentClass = classNames("PageTitle", className, {
    withBackText: !!backText,
    withoutClose: !onClose && !onBack,
    withTitle: !!title && (!!onBack || !!onClose),
    onlyTitle: !onBack && !onClose,
  });
  const pageTitleClass = classNames("PageTitle__title", {
    onlyTitle: !onBack && !onClose,
  });

  const pageTitleBack = classNames("PageTitle__back", {
    onlyTitle: !onBack && !onClose,
  });

  const isCrossVisible =
    title !== "wheel.popup.again.header" &&
    location?.pathname.includes("chicks-azerbaijan");

  return (
    <div className={componentClass}>
      <button type="button" className={pageTitleBack} onClick={handleBack}>
        {onBack && (
          <Suspense fallback="">
            <LazyArrowBack />
          </Suspense>
        )}{" "}
        {backText && <div className="PageTitle__back_text">{t(backText)}</div>}
      </button>

      <div className={pageTitleClass}>
        {title && (typeof title === "string" ? t(title) : title)}
      </div>
      {!!titleComponent && titleComponent}

      {!onClose && onBack && <div className="PageTitle__back_placeholder" />}
      {(onClose || isCrossVisible) && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <button
          type="button"
          className="PageTitle__close"
          onClick={handleClose}
        >
          <Suspense fallback="">
            <LazyClose />
          </Suspense>
        </button>
      )}
    </div>
  );
};

export default PageTitle;
